import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import WhatsAppFloat from '../components/WhatsAppFloat';

const Recruitment = () => {
    const [alertMessage, setAlertMessage] = useState(null);
    const [alertType, setAlertType] = useState(null);

    useEffect(() => {
        // Force hide spinner immediately
        const spinner = document.getElementById('spinner');
        if (spinner) {
            spinner.classList.remove('show');
            spinner.style.display = 'none';
            spinner.style.opacity = '0';
            spinner.style.visibility = 'hidden';
        }
        if (window.WOW) {
            new window.WOW().init();
        }
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();

        const form = event.target;
        const formData = new FormData(form);

        setAlertMessage("Processing your submission...");
        setAlertType('success');

        try {
            const response = await fetch(form.action, {
                method: 'POST',
                body: formData,
                mode: 'cors'
            });

            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }

            const data = await response.json();

            if (data.result === "Success") {
                const link = "https://docs.google.com/forms/d/e/1FAIpQLScc4fY8crTxCglaym0ZCvPlJsrvGzNFurrqN3GOXzKPl4DyzQ/viewform";
                setAlertMessage(link);
                setAlertType('successForm');
                form.reset();
            } else {
                setAlertMessage("There was an error. Please try again.");
                setAlertType('error');
            }
        } catch (error) {
            console.error('Fetch Error:', error);
            setAlertMessage("There was an error. Please try again.");
            setAlertType('error');
        }
    };

    const renderAlert = () => {
        if (!alertMessage) return null;

        let style = {};
        let content = null;

        if (alertType === 'success') {
            style = { backgroundColor: "#d4edda", color: "#155724", border: "1px solid #c3e6cb", padding: '10px', borderRadius: '5px', marginTop: '15px' };
            content = alertMessage;
        } else if (alertType === 'successForm') {
            style = { backgroundColor: "#d4edda", color: "#155724", border: "1px solid #c3e6cb", padding: '10px', borderRadius: '5px', marginTop: '15px' };
            content = (
                <>
                    Thank you! We appreciate your time to send your application. You can fill the full form <a href={alertMessage} target="_blank" rel="noreferrer" style={{ color: '#9f0b29', fontWeight: 'bold' }}>Click Here📝‼️</a>.
                </>
            );
        } else if (alertType === 'error') {
            style = { backgroundColor: "#f8d7da", color: "#721c24", border: "1px solid #f5c6cb", padding: '10px', borderRadius: '5px', marginTop: '15px' };
            content = alertMessage;
        }

        return <div className="alert" style={style}>{content}</div>;
    };

    return (
        <>
            <WhatsAppFloat />
            <Navbar />

            {/* Page Header Start */}
            <div className="container-fluid page-header mb-5 wow fadeIn" data-wow-delay="0.1s">
                <div className="container">
                    <h1 className="display-3 mb-4 animated slideInDown">Recruitment</h1>
                    <nav aria-label="breadcrumb animated slideInDown">
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item"><a href="/">Home</a></li>
                            <li className="breadcrumb-item"><a href="/recruitment">Pages</a></li>
                            <li className="breadcrumb-item active" aria-current="page">Recruitments</li>
                        </ol>
                    </nav>
                </div>
            </div>
            {/* Page Header End */}

            {/* Recruitment Info Start */}
            <div className="container-xxl py-5">
                <div className="container">
                    <div className="row g-5">
                        <div className="col-lg-12 wow fadeIn" data-wow-delay="0.1s">
                            <h2 className="mb-4">Join Our Team at WebBears!</h2>
                            <p className="d-inline-block border rounded text-primary fw-semi-bold py-1 px-3">Please Read Description</p>
                            <p className="lead mb-4">WebBears is inviting passionate interns and professionals to join our team for exciting projects! We provide you with projects that match your skills, so you don’t need to search for them yourself. Just focus on your strengths, and we’ll handle client acquisition and management for you.</p>
                            <p className="lead mb-4">Complete your work within the timeline, and you can earn 50% or more of the project profits. Along with profit-sharing, you'll gain valuable experience and a chance to work on impactful projects.</p>
                            <p className="lead mb-4">Join WebBears, where your hard work is rewarded, and your career is taken to new heights without the stress of finding projects. Be part of a supportive team that’s dedicated to your growth and success!</p>
                        </div>
                    </div>
                </div>
            </div>
            {/* Recruitment Info End */}

            {/* Recruitment Form Start */}
            <div className="container-xxl py-5">
                <div class="container">
                    <div className="row g-5">
                        <div className="col-lg-6 wow fadeIn" data-wow-delay="0.1s">
                            <p className="d-inline-block border rounded text-primary fw-semi-bold py-1 px-3">FullTime-Recruitments</p>
                            <h1 className="display-5 mb-4">Join WebBears - Submit Your Details</h1>
                            <form id="RecruitmentForm" method="post" onSubmit={handleSubmit} action="https://script.google.com/macros/s/AKfycbxZfWN2yEogt-LC5UTj18SElcbWcKHtISivo_OM74CAV4N7Z4_Af8OZXgmQ6ggFOGWFTQ/exec">
                                <div className="row g-3">
                                    <div className="col-sm-6">
                                        <div className="form-floating">
                                            <input type="text" className="form-control" id="firstName" name="firstName" placeholder="First Name" required />
                                            <label htmlFor="firstName">First Name</label>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-floating">
                                            <input type="text" className="form-control" id="lastName" name="lastName" placeholder="Last Name" required />
                                            <label htmlFor="lastName">Last Name</label>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-floating">
                                            <input type="text" className="form-control" id="whatsapp" name="whatsapp" placeholder="WhatsApp Number" required />
                                            <label htmlFor="whatsapp">WhatsApp Number</label>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-floating">
                                            <input type="email" className="form-control" id="email" name="email" placeholder="Email" required />
                                            <label htmlFor="email">Email</label>
                                        </div>
                                    </div>
                                    <div className="col-12 text-center">
                                        <button className="btn btn-primary w-100 py-3" type="submit">Submit Application</button>
                                    </div>
                                </div>
                            </form>
                            <div id="alertContainer">
                                {renderAlert()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Recruitment Form End */}

            <Footer />
        </>
    );
};

export default Recruitment;
